var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 5,
    fill: "#272A3A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.8889,
    height: 12,
    transform: "translate(8.59375 9)",
    fill: "#272A3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6476 18.375C16.6476 18.5821 16.4672 18.75 16.2448 18.75L9.80035 18.75C9.5779 18.75 9.39757 18.5821 9.39757 18.375L9.39757 11.625C9.39757 11.4179 9.5779 11.25 9.80035 11.25L16.2448 11.25C16.4672 11.25 16.6476 11.4179 16.6476 11.625L16.6476 13.125C16.6476 13.3321 16.8279 13.5 17.0503 13.5C17.2728 13.5 17.4531 13.3321 17.4531 13.125L17.4531 11.625C17.4531 11.0037 16.9121 10.5 16.2448 10.5L9.80035 10.5C9.133 10.5 8.59201 11.0037 8.59201 11.625L8.59201 18.375C8.59201 18.9963 9.133 19.5 9.80035 19.5L16.2448 19.5C16.9121 19.5 17.4531 18.9963 17.4531 18.375L17.4531 16.875C17.4531 16.6679 17.2728 16.5 17.0503 16.5C16.8279 16.5 16.6476 16.6679 16.6476 16.875L16.6476 18.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3625 15.2652C21.5198 15.1187 21.5198 14.8813 21.3625 14.7348L18.9458 12.4848C18.7885 12.3384 18.5335 12.3384 18.3762 12.4848C18.2189 12.6313 18.2189 12.8687 18.3762 13.0152L20.1053 14.625L13.0221 14.625C12.7997 14.625 12.6194 14.7929 12.6194 15C12.6194 15.2071 12.7997 15.375 13.0221 15.375L20.1053 15.375L18.3762 16.9848C18.2189 17.1313 18.2189 17.3687 18.3762 17.5152C18.5335 17.6616 18.7885 17.6616 18.9458 17.5152L21.3625 15.2652Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrow);
export default __webpack_public_path__ + "static/media/black-arrow.1ed3b11ae4020b0a8ad47033a4b2999d.svg";
export { ForwardRef as ReactComponent };